/* eslint-disable eqeqeq */
import {
  Box,
  Button,
  Flex,
  Heading,
  SimpleGrid,
  Table,
  TableContainer,
  Tbody,
  Td,
  Thead,
  Tr,
} from "@chakra-ui/react";
import * as React from "react";
import { BiInfoCircle } from "react-icons/bi";
import { myReferals, redeemProduct } from "../CommonProps";
import { Common } from "../CommonService";
import ConfirmationDialog from "../Message/ConfirmationDialog";
import { StampedService } from "../StampedService";
import { IBodyshopService } from "../UserService";
import "./FlowGetter.css";
import { JobEstimationDetail } from "../modals/JobEstimationDetail";
import { IBSAdonisService } from "../Services/IBSAdonisService";
const CryptoJS = require("crypto-js/hmac-sha256");
export interface IFlowGetterProps {
  points: number;
  owner: string;
  referralCode: string;
  stampedService: StampedService;
  ibsService: IBodyshopService;
  estimateDetails: JobEstimationDetail;
  pointsRewarded: (newValue: number) => void;
  showHideLoader: (value: boolean) => void;
  isUserSubscribed: boolean;
  UserSubscribedCallback: () => void;
  myReferals: myReferals[];
  redeemProducts: redeemProduct[];
  productRedeemSuccess: () => void;
}
const trophy = require("./../assets/images/trophySvg.svg").default,
  iconInfo = require("./../assets/images/iconInfo.png").default;
export interface IFlowGetterState {
  buttonText: string;
  colorClass: string;
  selectedTab: flowGetterTab;
  isUserSubscribed: boolean;
  showRedeemConfirmation: boolean;
  reddemProduct: redeemProduct;
}
export enum flowGetterTab {
  rewards = "Rewards",
  earn = "Earn",
  activities = "Activities",
  refer = "Refer",
  myReferals = "MyReferals",
}

export default class FlowGetter extends React.Component<
  IFlowGetterProps,
  IFlowGetterState
> {
  private common = new Common();
  private ibsAdonisService = new IBSAdonisService();
  constructor(props: IFlowGetterProps) {
    super(props);
    this.state = {
      buttonText: this.getButtonText(),
      colorClass: this.getColorClass(),
      selectedTab: flowGetterTab.activities,
      isUserSubscribed: this.props.isUserSubscribed,
      reddemProduct: null as any,
      showRedeemConfirmation: false,
    };
    this.processLoyaltyUi();
  }

  processLoyaltyUi() {
    let StampedFn = (window as any).StampedFn;
    if (this.props.stampedService.isFirstTime) {
      StampedFn.init({
        apiKey: this.props.stampedService.apiKeyPublic,
        storeUrl: "portal.flowautobody.com.au",
      });
    }
    // StampedFn.on('stamped:init:starting', () => {
    let obj: any = {};
    if (this.props.stampedService.currentCustomer) {
      obj.customerId = this.props.stampedService.currentCustomer.id; // your own internal numeric ID of the customer
      obj.customerEmail = this.props.stampedService.currentCustomer.email;
      obj.customerFirstName =
        this.props.stampedService.currentCustomer.firstName;
      obj.customerLastName = this.props.stampedService.currentCustomer.lastName;
      obj.customerTags = this.props.stampedService.currentCustomer.tags; // your internal customer tags, separate each tag with comma e.g. Wholesale, VIP
      obj.totalOrders =
        this.props.stampedService.currentCustomer.sentimentScore; // numeric indicating customer's total orders placed with your store
      obj.totalSpent = this.props.stampedService.currentCustomer.totalSpent; // numeric indicating customer's total amount spent across all orders
      obj.isAcceptMarketing = true; // true or false
      //let key = createHmac(this.props.stampedService.currentCustomer.id + this.props.stampedService.currentCustomer.email, this.props.stampedService.apiKeyPrivate);
      let key = CryptoJS(
        this.props.stampedService.currentCustomer.id +
          this.props.stampedService.currentCustomer.email,
        this.props.stampedService.apiKeyPrivate
      );
      obj.authToken = key.toString(); // btoa(this.props.stampedService.currentCustomer.id + ":" + this.props.stampedService.currentCustomer.email + ":" + this.props.stampedService.apiKeyPrivate); // CustomerId + CustomerEmail (with API Private key as HMAC key)
    }
    StampedFn.initRewards(obj);

    this.props.stampedService.isFirstTime = false;
  }

  componentDidUpdate(prevProps: IFlowGetterProps, prevState: IFlowGetterState) {
    if (this.props.points != prevProps.points) {
      this.setState({
        buttonText: this.getButtonText(),
        colorClass: this.getColorClass(),
      });
    }
    if (this.props.isUserSubscribed != prevProps.isUserSubscribed) {
      this.setState({ isUserSubscribed: this.props.isUserSubscribed });
    }
  }

  getButtonText() {
    return this.props.points < 1000
      ? "Blue"
      : this.props.points < 1500
      ? "Gold"
      : "Platinum";
  }
  getColorClass() {
    return this.props.points < 1000
      ? "blue"
      : this.props.points < 1500
      ? "gold"
      : "platinum";
  }

  renderSubscribeUserContent() {
    return (
      <>
        <Heading color="blue.700" size="md">
          Haven't you subscribed yet? <br />
          Join us today and start earning!
        </Heading>
        <div className={"row"}>
          <div className={""}>
            <div className={"bottomCheck"}>
              <input
                type="checkbox"
                disabled={false}
                checked={this.state.isUserSubscribed}
                onChange={(e) => {
                  this.setState(
                    { isUserSubscribed: !this.state.isUserSubscribed },
                    () => {
                      if (this.state.isUserSubscribed) {
                        this.props.showHideLoader(true);
                        this.common.createCustomerInStamped(
                          this.props.stampedService,
                          this.props.estimateDetails,
                          this.props.ibsService,
                          this.props.showHideLoader.bind(this),
                          () => {
                            this.props.UserSubscribedCallback();
                          }
                        );
                      }
                    }
                  );
                }}
              />
              <span className={"checkLabel"}>
                Opt into the Rewards Program. Learn more about it{" "}
                <a href="/">here</a>
              </span>
            </div>
          </div>
        </div>
      </>
    );
  }
  renderEarningContent() {
    let pending = this.props.stampedService.availablePoints - this.props.points;
    return (
      <>
        <Heading color="blue.700" size="lg">
          Claim rewards!
        </Heading>
        <div className={"row"}>
          <div className={"col-6 tierTitle"}>Your Tier</div>
          <div className={"col-6 text-end"} style={{ position: "relative" }}>
            <button type={"button"} className={"tierButton btn"}>
              <img src={trophy} alt="Trophy" className={"trophy"} />{" "}
              {this.state.buttonText}
            </button>
            <img src={iconInfo} alt="Info Icon" className={"infoIcon"} />
          </div>
          {/* <div className={"roundUserText mt-3"}>{"Hey " + (this.props.owner ? this.props.owner : "") + ",\nyou’re currently have"}</div> */}
        </div>
        <div>
          <div className={"roundMain"}>
            <div className={"points"}>
              {this.props.stampedService.availablePoints}
            </div>
            <div className={"pointBottom"}>Available Points</div>
          </div>
          <div className="totalPoints">
            <div>
              Balance
              <span className="otherPoints balance">{this.props.points}</span>
            </div>
            {pending != 0 ? (
              <div>
                {" "}
                Pending
                <span
                  style={{
                    background:
                      Math.sign(pending) === -1 ? "#E96565" : "#48BB78",
                  }}
                  className="otherPoints pending"
                >
                  {pending > 0 ? "+" + pending.toString() : pending}
                </span>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        {this.renderTabs()}
        {this.renderTabContent()}
        {/* {this.renderTiles()} */}
        {this.renderEarnTiles()}
        {this.renderActivities()}
        {/* {this.renderMyReferrals()} */}
      </>
    );
  }
  public render(): React.ReactElement<IFlowGetterProps> {
    return (
      <div className={[this.state.colorClass, "section-wrapper"].join(" ")}>
        <div className="full-width">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 pl-0">
            {this.props.isUserSubscribed
              ? this.renderEarningContent()
              : this.renderSubscribeUserContent()}
          </div>
        </div>
        {this.state.showRedeemConfirmation ? (
          <ConfirmationDialog
            buttons={
              <div>
                <button
                  type="button"
                  onClick={() => {
                    this.setState({ showRedeemConfirmation: false });
                    this.reddemEstimate(this.state.reddemProduct);
                  }}
                >
                  Yes
                </button>
                <button
                  type="button"
                  onClick={() => {
                    this.setState({ showRedeemConfirmation: false });
                  }}
                >
                  No
                </button>
              </div>
            }
            closeCallback={() =>
              this.setState({ showRedeemConfirmation: false })
            }
            icon={<BiInfoCircle />}
            messageText={`Are you sure you want to redeem product(${
              this.state.reddemProduct
                ? this.state.reddemProduct.displayAsField
                : ""
            })?`}
            title={"Reddem Product Confirmation"}
          />
        ) : undefined}
      </div>
    );
  }

  renderMyReferrals() {
    return (
      <TableContainer boxShadow={"md"} borderRadius={"md"}>
        <Table colorScheme={"blue"}>
          <Thead bg={"blue.700"} color="white">
            <Tr>
              <Td>Name</Td>
              <Td>E-mail</Td>
              <Td>Status</Td>
              <Td>Reference</Td>
            </Tr>
          </Thead>
          <Tbody>
            {this.props.myReferals.map((ref) => (
              <Tr>
                <Td>{ref.name}</Td>
                <Td>{ref.email}</Td>
                <Td>{ref.status}</Td>
                <Td>{ref.points}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    );
  }
  renderEarnTiles() {
    return (
      <div
        className={this.state.selectedTab != flowGetterTab.earn ? "hide" : ""}
      >
        <div
          id="stamped-rewards-widget"
          data-widget-type="rewards-earnings-v2"
        ></div>
      </div>
    );
  }

  renderTabContent() {
    switch (this.state.selectedTab) {
      case flowGetterTab.rewards:
        return this.renderTiles();
      // case "Earn": return this.renderEarnTiles();
      case flowGetterTab.refer:
        return this.renderRefer();
      case flowGetterTab.myReferals:
        return this.renderMyReferrals();
      // case "Activities": return this.renderActivities();
    }
  }
  renderActivities() {
    return (
      <div
        className={
          this.state.selectedTab != flowGetterTab.activities ? "hide" : ""
        }
      >
        <div
          id="stamped-rewards-widget"
          data-widget-type="rewards-activities"
        ></div>
      </div>
    );
  }

  renderRefer() {
    let referral = this.props.stampedService.referralUrl;
    return (
      <div>
        <div
          className={"secInfo"}
          onClick={() => {
            navigator.clipboard.writeText(referral);
            alert(
              "You have copied your referral link, share and start earning."
            );
          }}
        >
          {" "}
          {referral}
        </div>
        <Button w="100%" mt={6} colorScheme="cyan" bg={"cyan.300"}>
          <a href={referral} target="_blank" rel="noreferrer">
            Share
          </a>
        </Button>
      </div>
    );
  }
  renderTabs() {
    let buttons = [
      { name: "Rewards", key: flowGetterTab.rewards },
      { name: "Earn", key: flowGetterTab.earn },
      { name: "Activities", key: flowGetterTab.activities },
      { name: "Refer", key: flowGetterTab.refer },
    ];
    if (this.props.myReferals.length > 0) {
      buttons.push({ name: "My Referrals", key: flowGetterTab.myReferals });
    }
    return (
      <Flex overflowX={"auto"} className="tab" gap="10px">
        {buttons.map((e) => (
          <Button
            key={e.key}
            minW={"fit-content"}
            w="100%"
            colorScheme="blue"
            variant={e.key == this.state.selectedTab ? "solid" : "outline"}
            className={"tabButton"}
            onClick={() => {
              this.setState({ selectedTab: e.key });
            }}
          >
            {e.name}
          </Button>
        ))}
      </Flex>
    );
  }
  renderTiles() {
    return (
      <SimpleGrid columns={[2, null, 3]} spacing="10px">
        {this.props.redeemProducts.map((e) => {
          return (
            <Box
              p="4"
              border={"1px"}
              borderColor={"gray.200"}
              boxShadow="md"
              borderRadius={"md"}
            >
              <div className={"code"}>Code: {e.refNo}</div>
              <div className={"total"}>Value: $ {e.total}</div>
              <div className={"productTitle"}>{e.displayAsField}</div>
              <div className={"productDesc"}>{e.contactNotes}</div>
              <div>{e.sumInsured} Points</div>
              <Button
                w="100%"
                colorScheme="cyan"
                bg={"cyan.300"}
                onClick={(ev) => this.showRedeemConfirmation(e)}
                disabled={
                  this.props.stampedService.currentCustomerPoints < e.sumInsured
                }
              >
                Redeem
              </Button>
            </Box>
          );
        })}
      </SimpleGrid>
    );
  }
  reddemEstimate(product: redeemProduct) {
    this.ibsAdonisService
      .redeemEstimate(
        this.props.estimateDetails.estimateId,
        this.props.estimateDetails.primaryDetailId,
        product.estimateId,
        product.primaryDetailsId
      )
      .then((response: any) => {
        if (response.isSuccess) {
          this.props.stampedService
            .pointsAdjustment(
              this.props.stampedService.customerId,
              -product.sumInsured,
              "Redeem Product"
            )
            .then((res1) => {
              debugger;
              this.ibsAdonisService
                .sendEmail(
                  "Hi, The product('" +
                    product.displayAsField +
                    "') is redeemed.\nYou can Schedule booking from <a href='https://portal.flowautobody.com.au/?estimateid=" +
                    response.Data +
                    "&stype=booking'>here</a>",
                  "Product Redeem Success",
                  this.props.estimateDetails.estimateId,
                  this.props.estimateDetails.estimateNumber.toString()
                )
                .then((Res) => {
                  this.props.productRedeemSuccess();
                });
            });
        }
      });
  }
  showRedeemConfirmation(product: redeemProduct) {
    this.setState({ showRedeemConfirmation: true, reddemProduct: product });
  }
}
